// TODO(ngoldenberg): Requested here (https://github.com/urbansim/account-management-ui/issues/332)
// some resources are still not being offered to client-facing users, so they must remain hidden
// until we are ready to let users interact with it
export const hiddenAclResources = [
  "settings",
  "basemaps",
  "building_types",
  "cities",
  "collection_templates",
  "customs",
  "dashboards",
  "formats",
  "geocoder",
  "height",
  "measurement_systems",
  "parcels",
  "place_type_ids",
  "region",
  "rents",
  "reports",
  "simulations_downloads",
  "subscription_options",
  "subscriptions",
  "tags",
  "thread",
  "thread_location",
  "time_zones",
  "upload_types",
  "user_types"
];
